/**
 * Auth User Reducers
 */
import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGOUT_USER, ME, LOGIN_LOADING } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
  loading: false,
  token: localStorage.getItem('token'),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true };

    case LOGIN_USER_SUCCESS:
      return { ...state, loading: false, token: action.payload.token };

    case LOGIN_USER_FAILURE:
      return { ...state, loading: false };

    case LOGOUT_USER:
      return { ...state, user: null, token: null };

    case ME:
      return { ...state, user: action.payload };

    case LOGIN_LOADING:
      return { ...state, loading: action.payload };

    default:
      return { ...state };
  }
};
